import { render } from "./BuzzLatestPostWidget.vue?vue&type=template&id=f8f18dc0&scoped=true"
import script from "./BuzzLatestPostWidget.vue?vue&type=script&lang=js"
export * from "./BuzzLatestPostWidget.vue?vue&type=script&lang=js"

import "./buzz-latest-post-widget.scss?vue&type=style&index=0&id=f8f18dc0&lang=scss&scoped=true"

import exportComponent from "/Users/thabangteddy/Downloads/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8f18dc0"]])

export default __exports__